export const needs = state => state.inventory.itemSummary.needs;
export const isFetching = state => state.inventory.itemSummary.fetching;
